/** Module-level bridge so any file can await themed confirm without useConfirm(). */
let confirmImpl = null;

export function registerConfirm(fn) {
  confirmImpl = fn;
}

export function unregisterConfirm() {
  confirmImpl = null;
}

export async function confirmDialog(message, options = {}) {
  if (confirmImpl) {
    return confirmImpl(message, options);
  }
  return window.confirm(message);
}
